import { render, staticRenderFns } from "./patientsPortalForm.vue?vue&type=template&id=8cec9598&"
import script from "./patientsPortalForm.vue?vue&type=script&lang=js&"
export * from "./patientsPortalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports